import { styled } from "@mui/material";
import { iframe } from "../../helpers/environment";

export const FullHeightContainer = styled("div")(() => ({
  height: iframe ? "100vh" : "100%",
}));
